<script setup>
import { ref, onMounted, nextTick, watch, computed } from "vue";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useRequestsStore } from "@/stores/storeRequests";
import { useValidation } from "@/utils/useValidataion";
import Inputmask from "inputmask";

const storeField = useFieldsStore();
const storeRequests = useRequestsStore();

const value = ref(null);
const inputRef = ref(null);
const errorText = ref(null)

const heightErrorText = computed(() => {
    if (errorText.value) {
        return errorText.value.offsetHeight;
    }
})

const { validation, isValid, isTouched, textError } = useValidation(value);

const props = defineProps({
	stateKey: {
		type: String,
	},
	placeholder: {
		type: String,
		default: "",
	},
	required: {
		type: Boolean,
	},
});

const applyMask = () => {
	if (inputRef.value) {
		const im = new Inputmask({
			mask: "+7 (999) 999-99-99",
			placeholder: "_",
			clearIncomplete: true,
			showMaskOnHover: false,
			oncomplete: () => validation(props.stateKey),
			onincomplete: () => validation(props.stateKey),
		});
		im.mask(inputRef.value);
	}
};

onMounted(() => {
	nextTick(() => {
		applyMask();
	});

	
});

watch(
	() => storeRequests.userData?.phone_number,
	(newVal) => {
		if (newVal !== value.value) {
			value.value = newVal ?? "";
		}
	},
	{ immediate: true }
);

const handleInput = (event) => {
	value.value = event.target.value;
	storeField.updateFields(props.stateKey, "title", value.value);
	validation(props.stateKey);
};
</script>
<!-- :value="value" -->
<template>
	<label :class="['input']">
		<!-- <div class="input__holder"> -->
			<input
				ref="inputRef"
				type="tel"
				:placeholder="placeholder"
				:required="required"
				:class="['input__field', isTouched && (isValid ? 'valid' : 'not-valid')]"
				@input="handleInput"
				@blur="validation(stateKey)"
				
				v-model="value"
			/>
			<span class="input__title"><slot></slot></span>
		<!-- </div> -->

		<Transition mode="out-in">
            <span v-if="!!textError" ref="errorText" class="input__error" :style="{ bottom: `${(heightErrorText + 10) * -1}px` }">{{ textError }}</span>
        </Transition>
	</label>
</template>
<style lang="scss" scoped>

.v-enter-active,
.v-leave-active {
    transition: all 0.25s ease-out;
}

.v-enter-from{
    opacity: 0;
  transform: translate(-50%, 10px);
}
.v-leave-to {
  opacity: 0;
  transform: translate(-50%, 10px);
}
</style>
